const orderStatus = new Map()
orderStatus.set('1', '进行中')
orderStatus.set('2', '审批通过')
orderStatus.set('3', '审批驳回')
orderStatus.set('4', '审批撤销')
orderStatus.set('5', '审批结束')

const costType = new Map()
costType.set('1', '人力成本')
costType.set('2', '机械成本')
costType.set('3', '材料成本')
costType.set('4', '间接费')

const laborCostType = new Map()
laborCostType.set('1', '工人点工')
laborCostType.set('2', '工人包月')
laborCostType.set('3', '班组点工')
laborCostType.set('4', '班组包工')
laborCostType.set('5', '工人加班')
laborCostType.set('6', '班组加班')

export {
  laborCostType,
  orderStatus,
  costType
}
